export default "__VITE_ASSET__CYW7Jbfy__"